export const i18n = {
  defaultLocale: 'tr',
  locales: ['tr', 'en', 'de'],
} as const

export type Locale = (typeof i18n)['locales'][number]

export const localeNames: Record<Locale, string> = {
  tr: 'Türkçe',
  en: 'English',
  de: 'Deutsch',
}

export const localePaths: Record<Locale, string> = {
  tr: '/tr',
  en: '/en',
  de: '/de',
}

export const localeUrls: Record<Locale, Record<string, string>> = {
  tr: {
    home: '/tr',
    about: '/tr/hakkimizda',
    contact: '/tr/iletisim',
    services: '/tr/hizmetlerimiz',
    doctor: '/tr/op-dr-baris-cin',
    aestheticsInTurkey: '/tr/turkiyede-estetik',
    paymentMethods: '/tr/odeme-yontemleri',
    kvkk: '/tr/kvkk',
    blog: '/tr/blog',
    ameliyatsizEstetik: '/tr/ameliyatsiz-estetik',
    kirisiklikTerlemeTedavisi: '/tr/ameliyatsiz-estetik/kirisiklik-terleme-tedavisi',
    ciltDolgusu: '/tr/ameliyatsiz-estetik/cilt-dolgusu',
    ciltBakimi: '/tr/ameliyatsiz-estetik/cilt-bakimi',
    medikalCiltBakimi: '/tr/ameliyatsiz-estetik/cilt-bakimi/medikal-cilt-bakimi',
    aquapeelCiltBakimi: '/tr/ameliyatsiz-estetik/cilt-bakimi/aquapeel-cilt-bakimi',
    dermapenUygulamasi: '/tr/ameliyatsiz-estetik/cilt-bakimi/dermapen-uygulamasi',
    pumpkinPeel: '/tr/ameliyatsiz-estetik/cilt-bakimi/pumpkin-peel',
    bolgeselIncelme: '/tr/ameliyatsiz-estetik/bolgesel-incelme',
    g5Masaj: '/tr/ameliyatsiz-estetik/bolgesel-incelme/g5-masaj',
    ipleAskilama: '/tr/ameliyatsiz-estetik/iple-askilama',
    mezoterapi: '/tr/ameliyatsiz-estetik/mezoterapi',
    cerrahiIslemler: '/tr/cerrahi-islemler',
    estetikCerrahi: '/tr/estetik-cerrahi',
    yuzEstetigi: '/tr/estetik-cerrahi/yuz-estetigi',
    burunEstetigi: '/tr/burun-estetigi',
    kasKaldirma: '/tr/estetik-cerrahi/yuz-estetigi/kas-kaldirma',
    kepceKulakEstetigi: '/tr/estetik-cerrahi/yuz-estetigi/kepce-kulak-estetigi',
    gamzeEstetigi: '/tr/estetik-cerrahi/yuz-estetigi/gamze-estetigi',
    yagEnjeksiyonu: '/tr/estetik-cerrahi/yuz-estetigi/yag-enjeksiyonu',
    yuzGerme: '/tr/estetik-cerrahi/yuz-estetigi/yuz-germe',
    alinGerme: '/tr/estetik-cerrahi/yuz-estetigi/alin-germe',
    boyunGerme: '/tr/estetik-cerrahi/yuz-estetigi/boyun-germe',
    bisektomi: '/tr/estetik-cerrahi/yuz-estetigi/bisektomi',
    benAlinmasi: '/tr/estetik-cerrahi/yuz-estetigi/ben-alinmasi',
    gidiLiposuction: '/tr/estetik-cerrahi/yuz-estetigi/gidi-liposuction',
    gogusEstetigi: '/tr/estetik-cerrahi/gogus-estetigi',
    memeBuyutme: '/tr/estetik-cerrahi/gogus-estetigi/meme-buyutme',
    memeDiklestirme: '/tr/estetik-cerrahi/gogus-estetigi/meme-diklestirme',
    memeKucultme: '/tr/estetik-cerrahi/gogus-estetigi/meme-kucultme',
    jinekomasti: '/tr/estetik-cerrahi/gogus-estetigi/jinekomasti',
    vucutEstetigi: '/tr/estetik-cerrahi/vucut-estetigi',
    karinGerme: '/tr/estetik-cerrahi/vucut-estetigi/karin-germe',
    liposuction: '/tr/estetik-cerrahi/vucut-estetigi/liposuction',
    brezilyaPoposuEstetigi: '/tr/estetik-cerrahi/vucut-estetigi/brezilya-poposu-estetigi',
    kolGerme: '/tr/estetik-cerrahi/vucut-estetigi/kol-germe',
    uylukGerme: '/tr/estetik-cerrahi/vucut-estetigi/uyluk-germe',
    genitalBolgeEstetigi: '/tr/estetik-cerrahi/vucut-estetigi/genital-bolge-estetigi',
    postBariatrikCerrahi: '/tr/estetik-cerrahi/vucut-estetigi/post-bariatrik-cerrahi',
    opDrBarisCin: '/tr/op-dr-baris-cin',
    turkiyedeEstetik: '/tr/turkiyede-estetik',
    odemeYontemleri: '/tr/odeme-yontemleri',
    iletisim: '/tr/iletisim',
  },
  en: {
    home: '/en',
    about: '/en/about-us',
    contact: '/en/contact',
    services: '/en/services',
    doctor: '/en/op-dr-baris-cin',
    aestheticsInTurkey: '/en/aesthetics-in-turkey',
    paymentMethods: '/en/payment-methods',
    kvkk: '/en/kvkk',
    blog: '/en/blog',
    ameliyatsizEstetik: '/en/non-surgical-aesthetics',
    kirisiklikTerlemeTedavisi: '/en/non-surgical-aesthetics/wrinkle-sweat-treatment',
    ciltDolgusu: '/en/non-surgical-aesthetics/skin-filler',
    ciltBakimi: '/en/non-surgical-aesthetics/skin-care',
    medikalCiltBakimi: '/en/non-surgical-aesthetics/skin-care/medical-skin-care',
    aquapeelCiltBakimi: '/en/non-surgical-aesthetics/skin-care/aquapeel-skin-care',
    dermapenUygulamasi: '/en/non-surgical-aesthetics/skin-care/dermapen-application',
    pumpkinPeel: '/en/non-surgical-aesthetics/skin-care/pumpkin-peel',
    bolgeselIncelme: '/en/non-surgical-aesthetics/regional-slimming',
    g5Masaj: '/en/non-surgical-aesthetics/regional-slimming/g5-massage',
    ipleAskilama: '/en/non-surgical-aesthetics/thread-lifting',
    mezoterapi: '/en/non-surgical-aesthetics/mesotherapy',
    cerrahiIslemler: '/en/surgical-procedures',
    estetikCerrahi: '/en/aesthetic-surgery',
    yuzEstetigi: '/en/aesthetic-surgery/facial-aesthetics',
    burunEstetigi: '/en/rhinoplasty',
    kasKaldirma: '/en/aesthetic-surgery/facial-aesthetics/eyebrow-lift',
    kepceKulakEstetigi: '/en/aesthetic-surgery/facial-aesthetics/ear-correction',
    gamzeEstetigi: '/en/aesthetic-surgery/facial-aesthetics/dimple-aesthetics',
    yagEnjeksiyonu: '/en/aesthetic-surgery/facial-aesthetics/fat-injection',
    yuzGerme: '/en/aesthetic-surgery/facial-aesthetics/face-lift',
    alinGerme: '/en/aesthetic-surgery/facial-aesthetics/forehead-lift',
    boyunGerme: '/en/aesthetic-surgery/facial-aesthetics/neck-lift',
    bisektomi: '/en/aesthetic-surgery/facial-aesthetics/buccal-fat-removal',
    benAlinmasi: '/en/aesthetic-surgery/facial-aesthetics/mole-removal',
    gidiLiposuction: '/en/aesthetic-surgery/facial-aesthetics/chin-liposuction',
    gogusEstetigi: '/en/aesthetic-surgery/breast-aesthetics',
    memeBuyutme: '/en/aesthetic-surgery/breast-aesthetics/breast-augmentation',
    memeDiklestirme: '/en/aesthetic-surgery/breast-aesthetics/breast-lift',
    memeKucultme: '/en/aesthetic-surgery/breast-aesthetics/breast-reduction',
    jinekomasti: '/en/aesthetic-surgery/breast-aesthetics/gynecomastia',
    vucutEstetigi: '/en/aesthetic-surgery/body-aesthetics',
    karinGerme: '/en/aesthetic-surgery/body-aesthetics/tummy-tuck',
    liposuction: '/en/aesthetic-surgery/body-aesthetics/liposuction',
    brezilyaPoposuEstetigi: '/en/aesthetic-surgery/body-aesthetics/brazilian-butt-lift',
    kolGerme: '/en/aesthetic-surgery/body-aesthetics/arm-lift',
    uylukGerme: '/en/aesthetic-surgery/body-aesthetics/thigh-lift',
    genitalBolgeEstetigi: '/en/aesthetic-surgery/body-aesthetics/genital-aesthetics',
    postBariatrikCerrahi: '/en/aesthetic-surgery/body-aesthetics/post-bariatric-surgery',
    opDrBarisCin: '/en/op-dr-baris-cin',
    turkiyedeEstetik: '/en/aesthetics-in-turkey',
    odemeYontemleri: '/en/payment-methods',
    iletisim: '/en/contact',
  },
  de: {
    home: '/de',
    about: '/de/uber-uns',
    contact: '/de/kontakt',
    services: '/de/dienstleistungen',
    doctor: '/de/op-dr-baris-cin',
    aestheticsInTurkey: '/de/asthetik-in-turkei',
    paymentMethods: '/de/zahlungsmethoden',
    kvkk: '/de/kvkk',
    blog: '/de/blog',
    ameliyatsizEstetik: '/de/nicht-chirurgische-asthetik',
    kirisiklikTerlemeTedavisi: '/de/nicht-chirurgische-asthetik/falten-schweissbehandlung',
    ciltDolgusu: '/de/nicht-chirurgische-asthetik/hautfuller',
    ciltBakimi: '/de/nicht-chirurgische-asthetik/hautpflege',
    medikalCiltBakimi: '/de/nicht-chirurgische-asthetik/hautpflege/medizinische-hautpflege',
    aquapeelCiltBakimi: '/de/nicht-chirurgische-asthetik/hautpflege/aquapeel-hautpflege',
    dermapenUygulamasi: '/de/nicht-chirurgische-asthetik/hautpflege/dermapen-anwendung',
    pumpkinPeel: '/de/nicht-chirurgische-asthetik/hautpflege/pumpkin-peel',
    bolgeselIncelme: '/de/nicht-chirurgische-asthetik/regionale-schlankheitsbehandlung',
    g5Masaj: '/de/nicht-chirurgische-asthetik/regionale-schlankheitsbehandlung/g5-massage',
    ipleAskilama: '/de/nicht-chirurgische-asthetik/fadenlifting',
    mezoterapi: '/de/nicht-chirurgische-asthetik/mesotherapie',
    cerrahiIslemler: '/de/chirurgische-eingriffe',
    estetikCerrahi: '/de/asthetische-chirurgie',
    yuzEstetigi: '/de/asthetische-chirurgie/gesichtsasthetik',
    burunEstetigi: '/de/rhinoplastik',
    kasKaldirma: '/de/asthetische-chirurgie/gesichtsasthetik/brauenlifting',
    kepceKulakEstetigi: '/de/asthetische-chirurgie/gesichtsasthetik/ohrenkorrektur',
    gamzeEstetigi: '/de/asthetische-chirurgie/gesichtsasthetik/grubchenasthetik',
    yagEnjeksiyonu: '/de/asthetische-chirurgie/gesichtsasthetik/fettinjektion',
    yuzGerme: '/de/asthetische-chirurgie/gesichtsasthetik/gesichtslifting',
    alinGerme: '/de/asthetische-chirurgie/gesichtsasthetik/stirnlifting',
    boyunGerme: '/de/asthetische-chirurgie/gesichtsasthetik/halslifting',
    bisektomi: '/de/asthetische-chirurgie/gesichtsasthetik/wangenfettentfernung',
    benAlinmasi: '/de/asthetische-chirurgie/gesichtsasthetik/muttermalentfernung',
    gidiLiposuction: '/de/asthetische-chirurgie/gesichtsasthetik/kinn-liposuktion',
    gogusEstetigi: '/de/asthetische-chirurgie/brustasthetik',
    memeBuyutme: '/de/asthetische-chirurgie/brustasthetik/brustvergroesserung',
    memeDiklestirme: '/de/asthetische-chirurgie/brustasthetik/bruststraffung',
    memeKucultme: '/de/asthetische-chirurgie/brustasthetik/brustverkleinerung',
    jinekomasti: '/de/asthetische-chirurgie/brustasthetik/gynakomastie',
    vucutEstetigi: '/de/asthetische-chirurgie/korperasthetik',
    karinGerme: '/de/asthetische-chirurgie/korperasthetik/bauchdeckenstraffung',
    liposuction: '/de/asthetische-chirurgie/korperasthetik/liposuktion',
    brezilyaPoposuEstetigi: '/de/asthetische-chirurgie/korperasthetik/brazilian-butt-lift',
    kolGerme: '/de/asthetische-chirurgie/korperasthetik/armstraffung',
    uylukGerme: '/de/asthetische-chirurgie/korperasthetik/oberschenkelstraffung',
    genitalBolgeEstetigi: '/de/asthetische-chirurgie/korperasthetik/genitalasthetik',
    postBariatrikCerrahi: '/de/asthetische-chirurgie/korperasthetik/post-bariatrische-chirurgie',
    opDrBarisCin: '/de/op-dr-baris-cin',
    turkiyedeEstetik: '/de/asthetik-in-turkei',
    odemeYontemleri: '/de/zahlungsmethoden',
    iletisim: '/de/kontakt',
  },
}

// URL eşleştirmeleri için tip tanımları
type SlugMapping = {
  tr: string;
  en: string;
  de: string;
};

// Tüm sayfalar için slug eşleştirmeleri
export const slugMappings: Record<string, SlugMapping> = {
  'cilt-dolgusu': {
    tr: 'ameliyatsiz-estetik/cilt-dolgusu',
    en: 'non-surgical-aesthetics/skin-filler',
    de: 'nicht-chirurgische-asthetik/hautfuller',
  },
  'kirisiklik-terleme-tedavisi': {
    tr: 'ameliyatsiz-estetik/kirisiklik-terleme-tedavisi',
    en: 'non-surgical-aesthetics/wrinkle-sweat-treatment',
    de: 'nicht-chirurgische-asthetik/falten-schweissbehandlung',
  },
  'mezoterapi': {
    tr: 'ameliyatsiz-estetik/mezoterapi',
    en: 'non-surgical-aesthetics/mesotherapy',
    de: 'nicht-chirurgische-asthetik/mesotherapie',
  },
  'ameliyatsiz-estetik/iple-askilama': {
    tr: 'ameliyatsiz-estetik/iple-askilama',
    en: 'non-surgical-aesthetics/thread-lifting',
    de: 'nicht-chirurgische-asthetik/fadenlifting',
  },
  // Yeni sayfalar buraya eklenebilir
};

// URL'den slug'ı çıkar
export function extractSlugFromPath(path: string): string | null {
  const parts = path.split('/');
  const lastPart = parts[parts.length - 1];
  return lastPart || null;
}

// Slug'dan URL oluştur
export function getUrlForSlug(slug: string, locale: string): string {
  const mapping = slugMappings[slug];
  if (!mapping) return `/${locale}/${slug}`;
  return `/${locale}/${mapping[locale as keyof SlugMapping]}`;
}

// URL'den slug'ı bul
export function findSlugFromUrl(path: string, locale: string): string | null {
  const pathWithoutLocale = path.split('/').slice(2).join('/');
  
  // Tüm slug'ları kontrol et
  for (const [slug, mapping] of Object.entries(slugMappings)) {
    if (mapping[locale as keyof SlugMapping] === pathWithoutLocale) {
      return slug;
    }
  }
  
  return null;
}

// Slug'ın tüm dillerdeki URL'lerini döndür
export function getAllUrlsForSlug(slug: string): Record<string, string> {
  const mapping = slugMappings[slug];
  if (!mapping) return {};
  
  return {
    tr: `/${i18n.defaultLocale}/${mapping.tr}`,
    en: `/en/${mapping.en}`,
    de: `/de/${mapping.de}`,
  };
}

export const supportedLanguages = ['tr', 'en', 'de'] as const;
export type SupportedLanguage = typeof supportedLanguages[number];

export const defaultLanguage: SupportedLanguage = 'tr';

export const languageNames: Record<SupportedLanguage, string> = {
  tr: 'Türkçe',
  en: 'English',
  de: 'Deutsch',
};

export const reverseSlugMappings = Object.entries(slugMappings).reduce(
  (acc, [trSlug, mappings]) => {
    Object.entries(mappings).forEach(([lang, slug]) => {
      if (!acc[slug]) {
        acc[slug] = {};
      }
      acc[slug][lang] = trSlug;
    });
    return acc;
  },
  {} as Record<string, Record<string, string>>
); 